import { storageUtils } from './index'

const AUTH_TOKEN_KEY = 'olecio_auth_token'

const stripBearerPrefix = (token: string): string =>
  token.startsWith('Bearer ') ? token.slice(7) : token

export const authStorage = {
  getToken: (): string | null => {
    const token = storageUtils.get<string | null>(AUTH_TOKEN_KEY, null)
    return token ? stripBearerPrefix(token) : null
  },

  setToken: (token: string): void => {
    storageUtils.set(AUTH_TOKEN_KEY, stripBearerPrefix(token))
  },

  clearToken: (): void => {
    storageUtils.remove(AUTH_TOKEN_KEY)
  },

  persistTokenIfRequested: (token: string, stayConnected: boolean): void => {
    if (stayConnected) {
      authStorage.setToken(token)
    } else {
      authStorage.clearToken()
    }
  },
}
